import { axios } from '@/utils/request'

// App management
export function getOtpReportList (parameter = {}) {
  return axios({
    url: '/otpCountReport/list',
    method: 'post',
    data: parameter
  })
}


